import { Node_Type } from "./../../ricos-types/index.js";
import Table from "./table.js";
import TableCell from "./tableCell.js";
import TableRow from "./tableRow.js";
const nodeViewRenderers = {
  [Node_Type.TABLE]: Table,
  [Node_Type.TABLE_ROW]: TableRow,
  [Node_Type.TABLE_CELL]: TableCell
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
